var contentMixin = require('./core/mixins/content');
var riot = require('riot');
var bus = require('./core/events/bus');
var cookieMixin = require('./core/mixins/cookie');
var urlMixin = require('./core/mixins/url');
var formatterMixin = require('./core/mixins/formatter');
var sharedObservable = require('./core/mixins/sharedObservable');

require('./components/dealer-locator-container.tag');
require('./components/spinner/animated-spinner.tag');
require('./components/tabs/tabs.tag');
require('./components/results/dealer-results-container.tag');
require('./components/results/dealer-detail.tag');
require('./components/map/bing-map.tag');
require('./components/filters/dealer-filters.tag');
require('@acura/shared-components/src/components/acr-svg/acr-svg.tag');
require('@acura/shared-components/src/components/zip-input/zip-input.tag');

module.exports = {
  init: function init() {
    riot.mixin('bus', sharedObservable(bus(riot)));
    riot.mixin('cookie', cookieMixin);
    riot.mixin(urlMixin);
    riot.mixin(formatterMixin);
    riot.mixin(contentMixin.content());

    if (window.Utility) {
      window.Utility.loadSvgInMemory();
    }

    return riot.mount('dealer-locator-container')[0].bus;
  },
  initRaq: function initRaq() {
    riot.mixin('bus', sharedObservable(bus(riot)));
    riot.mixin('cookie', cookieMixin);
    riot.mixin(urlMixin);
    riot.mixin(formatterMixin);
    riot.mixin(contentMixin.content());

    if (window.Utility) {
      window.Utility.loadSvgInMemory();
    }

    return riot.mount('dealer-locator-container[data-is-embedded-in-raq="True"]')[0].bus;
  },
};
